var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaLogoBorderTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "27px",
    viewBox: "0 0 41 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa_logo_border_transavia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa_logo_border_transavia",
    transform: "translate(0.500000, 0.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#BCBCBC",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 26,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9094,7.69302 L11.4575,18.3127 L8.55333,18.3127 L6.36281,9.83927 C6.23,9.31687 6.1149,9.12562 5.70937,8.90604 C5.04885,8.54833 3.95802,8.21187 3,8.00292 L3.06552,7.69479 L7.74052,7.69479 C8.33552,7.69479 8.87208,8.09146 9.00667,8.77854 L10.163,14.9233 L13.0229,7.69479 L15.9094,7.69479 L15.9094,7.69302 Z M27.287,14.8472 C27.2994,12.044 23.4106,11.8899 23.4372,10.6379 C23.446,10.2572 23.8091,9.85167 24.6024,9.74896 C24.9955,9.6976 26.081,9.65865 27.3118,10.2235 L27.7934,7.97104 C27.1329,7.73198 26.2811,7.5 25.224,7.5 C22.5075,7.5 20.5968,8.94323 20.5808,11.0116 C20.5631,12.5398 21.9444,13.3933 22.9856,13.9016 C24.057,14.4222 24.4165,14.7569 24.4111,15.2208 C24.4041,15.9327 23.5576,16.2479 22.766,16.2603 C21.3848,16.2816 20.5844,15.8867 19.9451,15.5892 L19.4475,17.916 C20.0885,18.21 21.275,18.4668 22.5022,18.4809 C25.3904,18.4809 27.2781,17.0554 27.287,14.8472 Z M34.4589,18.3145 L37,18.3145 L34.7811,7.69302 L32.4366,7.69302 C31.9089,7.69302 31.4644,7.99937 31.2678,8.47219 L27.1453,18.3127 L30.03,18.3127 L30.6038,16.726 L34.1277,16.726 L34.4589,18.3145 Z M31.3935,14.5515 L32.8403,10.5635 L33.6726,14.5515 L31.3935,14.5515 Z M19.8335,7.69302 L17.5616,18.3127 L14.815,18.3127 L17.087,7.69302 L19.8335,7.69302 Z",
    id: "Shape",
    fill: "#1434CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogoBorderTransavia);
export default __webpack_public_path__ + "static/media/visa_logo_border_transavia.17a1e8b9739b5fc37c31396329de236b.svg";
export { ForwardRef as ReactComponent };